import crud from "./crud";
import crud_service from "@/services/crud";

const path = "producers";
const struct = {
  description: "",
  commissioned_at: null,
  ordinal: null,
  power_station_id: null,
  producer_type_id: null,
  power_curve_min_id: null,
  power_curve_moy_id: null,
  maintenance_tracked: true,
};
const generic = crud(path, struct);

const state = {
  all: [],
  solar: [],
  ...generic.state,
};

const getters = {
  ...generic.getters,
};

const mutations = {
  setAll(state, items) {
    state.all= items
  },
  setSolar(state, items) {
    state.solar = items
  },
  ...generic.mutations,
};

const actions = {
  ...generic.actions,
  getAll({commit}) {
    commit('setIsLoading', true)
    return new Promise((resolve, reject) => {
      crud_service.fetch(`${path}/mine`).then((items)=>{
        commit("setAll",items);
        resolve(items);
        commit('setIsLoading', false);
        }).catch((e)=>{
        reject();
    })})
  },
  setSolar({commit},items) {
    commit('setSolar', items);
  },
  setAll({commit},items) {
    commit('setAll', items);
  },
  getMine({ commit }) {
    return new Promise((resolve) => {
      crud_service.fetch(`${path}/mine`).then((items) => {
        commit("setItems", items);
        resolve(items);
      });
    });
  },

  getSolar({ commit }) {
    commit('setIsLoading', true);
    return new Promise((resolve, reject) => {
      crud_service.fetch(`${path}/get_solar`)
        .then((items) => {
          commit("setSolar", items);
          resolve(items);
          commit('setIsLoading', false);
        })
        .catch((error) => {
          commit('setIsLoading', false);
          console.error('Error fetching solar producers data:', error);
          reject(error);
        });
    });
  },
  
  getWithAutomatons({ commit }, { search }) {
    const payload = {
      search: search,
    };
    return new Promise((resolve) => {
      crud_service.fetch(`${path}/with_automatons`, payload).then((items) => {
        commit("setSearch", items);
        resolve(items);
      });
    });
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
